<div #modal [id]="modalable.getModalId()" aria-hidden="true" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-xl" role="document" style="width: 100%; height: auto;">
        <div class="modal-content">
            <div class="modal-header">
                <div class="dropdown sharing-dropdown">
                    <button [attr.id]="'dropdownMenu' + modalable.sharing_link" aria-expanded="true"
                            aria-haspopup="true" class="btn btn-default dropdown-toggle"
                            data-bs-toggle="dropdown" type="button">
                        <i class="fa fa-share"></i>
                    </button>
                    <div [attr.aria-labelledby]="'dropdownMenu' + modalable.sharing_link" class="dropdown-menu">
                        <app-sharing-options
                                [sharingContext]="{ whiteboard: modalable, link: generateLink()}"></app-sharing-options>
                    </div>
                </div>
                <h2 class="title" data-bs-dismiss="modal">{{ whiteboardDrawing.name }}</h2>
            </div>
            <div class="modal-body">
                @if (videoError) {
                    <div>
                        Bei der Aufzeichnung ist leider ein Fehler aufgetreten.<br>
                        Das Video konnte nicht geladen werden.<br>
                        Bitte aktualisieren Sie die Seite oder starten Sie eine neue Aufzeichnung.<br>
                        Vielen Dank für Ihr Verständnis.
                    </div>
                } @else {
                    <app-video #video (error)="videoError = true;"
                               id="whiteboard_video"></app-video>
                }
            </div>
            <div class="modal-footer">
                <button (click)="stopVideo()" data-bs-dismiss="modal">zurück zum Buch</button>
            </div>
        </div>
    </div>
</div>
